import type { Counter } from "~/types";

/**
 * Web has no home-screen widgets — no-op. The native implementation
 * (`widget-bridge.native.ts`) writes the same snapshot to the platform's
 * shared storage so the Android/iOS widget extensions can read it without
 * the JS runtime.
 */
export function syncWidgetSnapshot(_counters: Counter[]): void {}
